import React from "react";
import {useToastContext} from "../hooks/useToast";
import {RawHTML} from "./RawHTML";
import "./Toast.css"
import {Button} from "./button/Button";

export const Toast = () => {
  const {toasts} = useToastContext();

  return (
      <div className="toasts">
        {toasts.map(toast => {
          return <div key={`toast-${toast.level}-${toast.text}`} className={`toast toast-${toast.level}`}>
            <RawHTML html={toast.text}/>
            <Button className="toast-close-button" onClick={toast.close}>Close</Button>
          </div>;
        })}
      </div>
  )
}